/* eslint-disable */
import React, { useState, useEffect, useMemo } from 'react';
import {
    MaterialReactTable,
    useMaterialReactTable,
} from 'material-react-table';
import {
    Box, Chip,
} from '@material-ui/core';
import _ from 'lodash';
import {
    TableBody, TableCell, TableHead, TableRow, Table, Tooltip, IconButton
} from '@material-ui/core';
import moment from 'moment';
import AutorenewIcon from '@mui/icons-material/Autorenew';

export function CustomTable({ tableData, setFarmerDetails, factoryType, setSelectedData, selectedData, rowSelection, setRowSelection, userAccess, isFDCFirstUser, isFDCSecondUser, isFinancialFirstUser,isFinancialSecondUser,setTotalOfTotalAmount,totalOfTotalAmount }) {
    const cloneData = tableData.map((item, index) => ({ ...item, uniqueId: `id-${index}` }));
    const data = cloneData;
    const columns = useMemo(
        () => [
            {
                accessorKey: 'invoiceNumber',
                header: 'Invoice Number',
                size: 150
            },
            {
                accessorKey: 'factoryName',
                header: 'Fresh Collection Center',
                size: 190
            },
            {
                accessorKey: 'farmerCode',
                header: 'Supplier Code',
                size: 190
            },
            {
                accessorKey: 'name',
                header: 'Supplier Name',
                size: 350
            },
            {
                accessorKey: 'totalAmount',
                header: 'Total Amount',
                size: 150,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                Cell: ({ cell }) => cell.getValue().toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            },
            {
                accessorKey: 'transactionType',
                header: 'Tran Type',
                size: 30
            },
            {
                accessorKey: 'statusID',
                header: 'Status',
                size: 150,
                muiTableHeadCellProps: {
                    align: 'center',
                },
                muiTableBodyCellProps: {
                    align: 'center',
                },
                Cell: ({ row }) => {
                    if (row.original.statusID === 1) {
                        return <Chip size="small" label="New" style={{ color: 'green', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 2) {
                        return <Chip size="small" label="FDC First Approved" style={{ color: '#75411b', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 3) {
                        return <Chip size="small" label="FDC Second Approved" style={{ color: '#d3910b', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 4) {
                        return <Chip size="small" label="Finance First Approved" style={{ color: '#B414F9', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 5) {
                        return <Chip size="small" label="Finance Second Approved" style={{ color: 'blue', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 6) {
                        return <Chip size="small" label="FDC First Rejected" style={{ color: 'red', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 7) {
                        return <Chip size="small" label="FDC Second Rejected" style={{ color: 'red', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 8) {
                        return <Chip size="small" label="Finance First Rejected" style={{ color: 'red', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 9) {
                        return <Chip size="small" label="Finance Second Rejected" style={{ color: 'red', textAlign: 'center' }} />
                    }
                    if (row.original.statusID === 10) {
                        return <Chip size="small" label="Error Status" style={{ color: 'red', textAlign: 'center' }} />
                    }
                    else {
                        <Chip size="small" label="Active" style={{ color: 'green', textAlign: 'center' }} />
                    }
                },
                enableColumnActions: false
            }
        ],
        [],
    );

    const shouldApplyCustomStyles = (statusID, factoryType) => {
        return (
            [5, 6, 7, 8, 9].includes(statusID) ||
            (statusID === 1 && factoryType === 5) ||
            (statusID === 2 && factoryType === 5) ||
            (statusID === 3 && factoryType === 1) ||
            (statusID === 4 && factoryType === 1)
        );
    };

    const shouldHideDisplay = (factoryType) => {
        return !(factoryType === 1 || factoryType === 5);
    };

    const permissionHandle = (statusID, isFDCFirstUser, isFDCSecondUser, isFinancialFirstUser,isFinancialSecondUser) => {
        return (
            (isFDCFirstUser && statusID === 1) ||
            (isFDCSecondUser && statusID === 2) ||
            (isFinancialFirstUser && statusID === 3)||
            (isFinancialSecondUser && statusID === 4)
        );
    };

    const shouldDisableSelectAll = (data, factoryType) => {
        return data.every(row => shouldHideDisplay(factoryType) || shouldApplyCustomStyles(row.statusID, factoryType) || (row.userAccess == 1) || !permissionHandle(row.statusID, isFDCFirstUser, isFDCSecondUser, isFinancialFirstUser,isFinancialSecondUser));
    };

    useEffect(() => {
        const filterdRowData = Object.keys(rowSelection)
            .filter((key) => rowSelection[key])
            .map((key) => data.find((row) => row.uniqueId === key))
            .filter((row) => row && !shouldApplyCustomStyles(row.statusID, factoryType) && !shouldHideDisplay(factoryType) &&
                row.userAccess !== 1 && permissionHandle(row.statusID, isFDCFirstUser, isFDCSecondUser, isFinancialFirstUser,isFinancialSecondUser));
        setSelectedData(filterdRowData);
    }, [rowSelection]);

    useEffect(()=>{
        var total = 0;
        selectedData.forEach((x) =>{
            total += x.totalAmount 
        })
        setTotalOfTotalAmount(total);
    },[selectedData])


    function changeTranType(row) {
        data.forEach((x, i) => {
            if (i == row.index) {
                if (row.original.transactionType == "CEFT") {
                    x.transactionType = "SLIPS"
                }
                else if (row.original.transactionType == "SLIPS") {
                    x.transactionType = "CEFT"
                }
            }
        })
        setFarmerDetails(data)
    }

    return (
        <div>
            {data.length > 0 ?
                <MaterialReactTable
                    columns={columns}
                    data={data}
                    enableSelectAll={!shouldDisableSelectAll(data, factoryType)}
                    enableFullScreenToggle={false}
                    enableHiding={false}
                    enableExpandAll={true}
                    enableRowSelection={!shouldDisableSelectAll(data, factoryType)}
                    getRowId={(row) => row.uniqueId}
                    onRowSelectionChange={setRowSelection}
                    state={{ rowSelection }}
                    enableColumnActions={false}
                    muiSearchTextFieldProps={{
                        placeholder: `Search`,
                        sx: { minWidth: '300px' },
                        variant: 'outlined'
                    }}
                    muiTableBodyCellProps={({ row }) => ({
                        sx: {
                            '& .Mui-checked, .MuiCheckbox-root': {
                                display: shouldHideDisplay(factoryType) || shouldApplyCustomStyles(row.original.statusID, factoryType) || row.original.userAccess == 1 ||
                                    !permissionHandle(row.original.statusID, isFDCFirstUser, isFDCSecondUser, isFinancialFirstUser,isFinancialSecondUser) ? 'none' : 'block',
                            },
                        },
                    })}
                    displayColumnDefOptions={{
                        'mrt-row-selection': {
                            grow: false,
                            Header: () => (
                                <Box sx={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'center' }}>
                                    <Box style={{ marginLeft: '10px' }}>Select All</Box>
                                </Box>
                            ),
                        }
                    }}
                    enableRowActions={true}
                    positionActionsColumn='last'
                    renderRowActions={({ row }) => (
                        row.original.transactionType != "CARG" && isFDCFirstUser == true && row.original.statusID == 1 && selectedData.length == 0 ?
                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                <Tooltip title="Change Tran Type">
                                    <IconButton
                                        //color="error"
                                        onClick={() => changeTranType(row)}
                                    >
                                        <AutorenewIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box> : null
                    )}
                    renderTopToolbarCustomActions={({ table }) => (
                        totalOfTotalAmount > 0 ? (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                            <Chip
                                label={
                                    <Box component="span" sx={{ fontWeight: 'bold' }}>
                                        Total Amount: {totalOfTotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </Box>
                                }
                                // color="primary"
                            />
                        </Box>
                        ) : null
                    )}
                    // muiTableToolbarProps={{
                    //     sx: {
                    //         '& .MuiToolbar-root': {
                    //             display: 'none',
                    //         },
                    //     },
                    // }}
                    // muiTableToolbarAlertBannerProps={{
                    //     sx: {
                    //         display: 'none',
                    //     },
                    // }}
                    renderDetailPanel={({ row }) => (
                        <Table aria-label="caption table" size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell align={'left'}>SKU Code</TableCell>
                                    <TableCell align={'left'}>SKU Name</TableCell>
                                    <TableCell align={'right'}>Price</TableCell>
                                    <TableCell align={'right'}>Quantity</TableCell>
                                    <TableCell align={'right'}>Total Amount</TableCell>
                                    <TableCell align={'center'}>Date</TableCell>
                                    <TableCell align={'center'}>Time</TableCell>
                                    <TableCell align={'center'}>Status</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {row.original.details.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell align={'left'}>
                                            {row.productCode}
                                        </TableCell>
                                        <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {row.productName}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {row.price == 0 ? "-" : parseFloat(row.price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {row.quanity == 0 ? "-" : parseFloat(row.quanity).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {row.totalAmount == 0 ? "-" : parseFloat(row.totalAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                        </TableCell>
                                        <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {row.date.split('T')[0]}
                                        </TableCell>
                                        <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {moment(row.time).format('hh:mm:ss a')}
                                        </TableCell>
                                        <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            {row.statusID === 1 ?
                                                <Chip size="small" label="New" style={{ color: 'green', textAlign: 'center' }} /> :
                                                row.statusID === 2 ?
                                                    <Chip size="small" label="FDC First Approved" style={{ color: '#75411b', textAlign: 'center' }} /> :
                                                    row.statusID === 3 ?
                                                        <Chip size="small" label="FDC Second Approved" style={{ color: '#d3910b', textAlign: 'center' }} /> :
                                                        row.statusID === 4 ?
                                                            <Chip size="small" label="Finance First Approved" style={{ color: '#B414F9', textAlign: 'center' }} /> :
                                                            row.statusID === 5 ?
                                                                <Chip size="small" label="Finance Second Approved" style={{ color: 'blue', textAlign: 'center' }} /> :
                                                                row.statusID === 6 ?
                                                                    <Chip size="small" label="FDC First Rejected" style={{ color: 'red', textAlign: 'center' }} /> :
                                                                    row.statusID === 7 ?
                                                                        <Chip size="small" label="FDC Second Rejected" style={{ color: 'red', textAlign: 'center' }} /> :
                                                                        row.statusID === 8 ?
                                                                            <Chip size="small" label="Finance First Rejected" style={{ color: 'red', textAlign: 'center' }} /> :
                                                                            row.statusID === 9 ?
                                                                                <Chip size="small" label="Finance Second Rejected" style={{ color: 'red', textAlign: 'center' }} /> :
                                                                                row.statusID === 10 ?
                                                                                    <Chip size="small" label="Error Status" style={{ color: 'red', textAlign: 'center' }} /> :

                                                                                    <Chip size="small" label="Active" style={{ color: 'green', textAlign: 'center' }} />
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    )}
                    initialState={{ density: 'compact', showGlobalFilter: true }}
                /> : null}
        </div>
    );
};

